import { render, staticRenderFns } from "./OppotunityDetail-info.vue?vue&type=template&id=7af9a1ae"
import script from "./OppotunityDetail-info.vue?vue&type=script&lang=js"
export * from "./OppotunityDetail-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports